import React from "react";

import { Carousel } from "shared/components/Carousel";

import SocialHero from "./SocialHero";

const SocialCarousel = ({
  posts = [],
  useGradient = false,
  gradientVariant = "blue"
}) => {
  if (!Array.isArray(posts) || posts.length === 0) {
    return null;
  }

  return (
    <Carousel
      items={posts}
      getKey={(post) => post.id}
      ariaLabel="Posty Facebook"
      controlsAlignment="center"
      renderItem={(post, index, controls) => (
        <SocialHero
          post={post}
          useGradient={useGradient}
          gradientVariant={gradientVariant}
          carouselControls={controls}
        />
      )}
    />
  );
};

export default SocialCarousel;